/**
 * @description 本文件存放的是全局的常量
 */

// 三端的token键值
export const eipToken = 'eipToken'

// 全局缓存模式 cookie|sessionStorage|localStorage
export const cacheMode = 'cookie'

// 用户登入登录配置字段映射
export const ssoConfigMap = {
  sso_school_name: 'titleConfig',
  sso_cas_model: 'mode',
  sso_cas_login_url: 'url',
  sso_cas_logout_url: 'logout',
  sso_oauth_client_id: 'clientId'
}